import i18next from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import Backend from "i18next-http-backend"
import { initReactI18next } from "react-i18next"
import referralEn from "./locales/en/adminReferralTranslation.json"
import clientEn from "./locales/en/clientIntakeTranslation.json"
import referralFr from "./locales/fr/adminReferralTranslation.json"
import clientFr from "./locales/fr/clientIntakeTranslation.json"

const DETECTION_OPTIONS = {
  order: ["navigator"],
}

// eslint-disable-next-line import/no-named-as-default-member
i18next
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: process.env.NODE_ENV === "development",
    detection: DETECTION_OPTIONS,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    nonExplicitSupportedLngs: true,
    resources: {
      en: {
        translation: {
          ...clientEn,
          ...referralEn,
        },
      },
      fr: {
        translation: {
          ...clientFr,
          ...referralFr,
        },
      },
    },
    // Allows "en-US" and "en-UK" to be implcitly supported when "en"
    // is supported
    supportedLngs: ["en", "fr"],
  })

export default i18next
